const selectors: Record<"dropdown" | "close" | "trigger", string> = {
  dropdown: "[data-dropdown-base]",
  close: "[data-dropdown-base-close]",
  trigger: "[data-dropdown-base-trigger]",
};

const classes: Record<"active", string> = {
  active: "active",
};

export const init = () => {
  const dropdowns = Array.from(document.querySelectorAll(selectors.dropdown));

  if (!dropdowns) return;

  document.addEventListener("click", (e) => {
    dropdowns.forEach((dropdown) => {
      if (dropdown.classList.contains(classes.active)) {
        dropdown.classList.remove(classes.active);
        return;
      }

      // @ts-ignore
      dropdown.classList[dropdown.contains(e.target) ? "add" : "remove"](classes.active);
    });
  });
};

document.addEventListener(
  "DOMContentLoaded",
  async function () {
    init();
  },
  {
    once: true,
  }
);
